import styled from 'styled-components';

const StyledRichTextContainer = styled.div`
  width: 100%;
  margin-top: 40px;

  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 40px 0 20px 0;
  }

  a {
    u {
      text-decoration: none;
    }
  }
  ul,
  ol {
    padding-left: 40px;
    margin-bottom: 20px;
    li {
      p {
        margin: 0 0 7px 0;
      }
    }
  }

  p {
    font-weight: 400;
    line-height: 160%;
  }

  hr {
    margin: 30px 0;
    border: 1px solid var(--neutral-5);
  }

  img {
    margin: 0px;
    width: 100% !important;
  }

  .rich-text-image--image {
    margin: 30px auto;
    box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08);
  }

  @media (min-width: 768px) {
    h1 {
      font-size: 49px;
    }
    h2 {
      font-size: 31px;
    }
    h3 {
      font-size: 25px;
    }
    h4,
    h5 {
      font-size: 20px;
    }
    h6 {
      letter-spacing: 0.05em;
      text-transform: uppercase;
      font-size: 15px;
      font-weight: 900;
      padding-bottom: 20px;
      line-height: 110%;
    }
    p {
      font-size: 18px;
    }
    li {
      font-size: 18px;
    }
  }

  .rich-text-embed {
    margin: 25px 0;
  }
`;

export { StyledRichTextContainer };
